import FigureList from "../../components/figure/FigureList";
import React from "react";

const FiguresPage = () => {
    return <FigureList />
}

export default FiguresPage;
